import { createContext } from "react";
const productDetailsContext = createContext({})
export default productDetailsContext